var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"title":_vm.isTruncated ? _vm.value : null,"placement":"topLeft","overlayStyle":_vm.overlayStyle}},[_c('div',{ref:"textRef",staticClass:"hide-long-text",class:{ 'is-truncated': _vm.isTruncated },on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.value || '-')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }